import GeschaeftspartnerlisteNewViva from "@/newviva/pages/Dashboardlisten/GeschaeftspartnerlisteNewViva";
import FirmenlisteNewViva from "@/newviva/pages/Dashboardlisten/FirmenlisteNewViva";
import Angebotliste from "@/newviva/pages/Dashboardlisten/Angebotliste.vue";
import GeschaeftspartnerNewViva from "@/newviva/pages/Masken/GeschaeftspartnerNewViva";
import FirmaNewViva from "@/newviva/pages/Masken/FirmaNewViva";
import Einsatz from "@/newviva/pages/Masken/Einsatz";
import Angebot from "@/newviva/pages/Masken/Angebot";
import Einsatzliste from "@/newviva/pages/Dashboardlisten/Einsatzliste.vue";
import Zeitraumliste from "@/newviva/pages/Dashboardlisten/Zeitraumliste.vue";
import Vergleichsstatistik from "@/newviva/pages/Dashboardlisten/Vergleichsstatistik.vue";


export default [
  {
    path: "/personenliste",
    name: "GeschaeftspartnerlisteNewViva",
    props: (route) => {
      return {
        rolleProp: route.params.rolleProp,
      };
    },
    component: GeschaeftspartnerlisteNewViva,
  },
  {
    path: "/unternehmensliste",
    name: "FirmenlisteNewViva",
    component: FirmenlisteNewViva,
  },
  {
    path: "/angebote",
    name: "Angebote",
    component: Angebotliste,
  },
  {
    path: "/person/:id?/:anzeige",
    name: "GeschaeftspartnerNewViva",
    props: (route) => {
      const a = parseInt(route.params.anzeige, 10);
      return {
        id: route.params.id,
        anzeige: isNaN(a) ? 0 : a,
      };
    },
    component: GeschaeftspartnerNewViva,
  },

  {
    path: "/unternehmen/:id?/:anzeige",
    name: "FirmaNewViva",
    props: (route) => {
      const a = parseInt(route.params.anzeige, 10);
      return {
        id: route.params.id,
        anzeige: isNaN(a) ? 0 : a,
      };
    },
    component: FirmaNewViva,
  },

  {
    path: "/zeitraumliste",
    name: "Zeitraumliste",
    component: Zeitraumliste,
  },

  {
    path: "/einsatzliste",
    name: "Einsatzliste",
    component: Einsatzliste,
  },

  {
    path: "/vergleichsstatistik",
    name: "Vergleichsstatistik",
    component: Vergleichsstatistik,
  },

  {
    path: "/einsatz/:id?/:angebotId?",
    name: "Einsatz",
    props: (route) => {
      return {
        id: route.params.id,
        angebotId: route.params.angebotId
      };
    },
    component: Einsatz,
  },

  {
    path: "/angebot/:id?/:anzeige",
    name: "Angebot",
    props: (route) => {
      const a = parseInt(route.params.anzeige, 10);
      return {
        id: route.params.id,
        anzeige: isNaN(a) ? 0 : a,
      };
    },
    component: Angebot,
  },
];
